export default __webpack_public_path__ + "static/media/pic5.9717fcc4.jpg";